<script setup lang="ts">
import BugsnagPerformance from '@bugsnag/browser-performance'

if (import.meta.client) {
  BugsnagPerformance.start({ apiKey: 'f4f6a13cd3bd61f9b5759af8b1f0c76c' })
}

const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp
const runtimeConfig = useRuntimeConfig()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - ${$i18n.t('siteTitle')}` : `${$i18n.t('siteTitle')}`
  },
  meta: [
    // stop iOS from auto-linking plain-text emails/phones/addresses with its own underline style
    { name: 'format-detection', content: 'telephone=no, email=no, address=no, date=no' }
  ],
  script: [
    {
      src: 'https://unpkg.com/large-small-dynamic-viewport-units-polyfill@0.0.4/dist/large-small-dynamic-viewport-units-polyfill.min.js'
    },
    { innerHTML: "!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '1417354892717545'); fbq('track', 'PageView');" }
  ],
  link: [
    { rel: 'icon', type: 'image/x-icon', href: `${runtimeConfig?.public?.baseUrl}/favicon/favicon-black.ico`, media: "(prefers-color-scheme: light)" },
    { rel: 'icon', type: 'image/x-icon', href: `${runtimeConfig?.public?.baseUrl}/favicon/favicon.ico`, media: "(prefers-color-scheme: dark)" },
  ]
})
</script>

<template>
  <div id="app">
    <NuxtLayout>
      <NavigationLoadingIndicatorComponent />
      <NuxtPage />
    </NuxtLayout>
    <img
      height="1"
      width="1"
      style="display:none"
      src="https://www.facebook.com/tr?id=1417354892717545&ev=PageView&noscript=1"
    />
  </div>
</template>
